import axios from 'axios' 
import qs from 'qs'
import config from '../../configure' 
import Login from '../../components/Login'

export const loadAcademicReg = () => {        
    return (dispatch) => {                      
        dispatch({ type: 'LOAD_ACADEMIC_REG_PENDING' })             
        const AuthStr = 'Bearer '.concat(localStorage.getItem('token')); 
        return axios({
            method: 'get',
            url: `${config.API_URL}/AcademicReg`,
            headers: { Authorization: AuthStr } 
         }).then(results => {        
            let semester = 'x'
            let year = 'x'
            var semester_year = []
            let acad = results.data.acad
            let gpa = results.data.gpa

            acad.forEach((value) => {          
                if (value.sem !== semester && value.yar !== year) {      
                  semester = value.sem
                  year = value.year
                  semester_year.push( {semester: value.sem, year: value.yar} )
                }
            });

            if (semester_year.length !== gpa.length) {
              const acad_arr = semester_year.filter( acad_semester => {
                let found = false
                for (let i = 0; i < gpa.length; i++) {
                  if (acad_semester.semester === gpa[i].sem && acad_semester.year === gpa[i].yar) {
                    found = true
                    break
                  }
                } 
                if (!found) { 
                  return acad_semester 
                } else {
                  return ''
                }
              })  
          
              acad_arr.forEach( acad_semester => {
                  results.data.gpa.push({
                      acrd: "",
                      ecrd: "",
                      gpa: "",
                      oca: "",
                      oce: "",
                      ogpa: "",
                      sem: acad_semester.semester,
                      yar: acad_semester.year
                    })                
              })
            }
            dispatch({ type: 'LOAD_ACADEMIC_REG_SUCCESS', payload: results.data })        
        }).catch(err => {           
          // if (err.response && err.response.status === 401) {          
              Login()
          // } else {
          //   dispatch({ type: 'LOAD_ACADEMIC_REG_REJECTED', payload: err })       
          // }                       
        })    
    } 
} 

export const updateGrade = (crs) => {  
    return (dispatch) => {                     
        dispatch({ type: 'UPDATE_GRADE', payload: crs })             
    } 
}

export const gpaPredict = (crs) => {        
    return (dispatch) => {             
        dispatch({ type: 'GPA_PREDICT_PENDING' })             
         const AuthStr = 'Bearer '.concat(localStorage.getItem('token')); 
         return axios({
            method: 'post',
            url: `${config.API_URL}/GpaPredict`,
            headers: { Authorization: AuthStr, 'content-type': 'application/x-www-form-urlencoded;charset=utf-8' }, 
            data: qs.stringify({
                courseno: crs
                // courseno: '[{"sem":"1","yar":"2563","std_id":"","crs":"001101","lec":"001","lab":"000","crd":"3","grd":"A","ern_crd_cnt":"1","ccrdc":"1","ecrdcm":"1"}]'
            }), 
        }).then(results => {  
            dispatch({ type: 'UPDATE_GPA', payload: results.data })                  
        }).catch(err => {   
          if (err.response && err.response.status === 401) {
            Login()
          }                       
        })    
    } 
}   